import React from 'react';

import { useSelector } from 'react-redux';
import withDbItemsWrapper from '../../../utils/hoc/dbItemsWrapper';
import ProductModal from './components/modals/ProductModal';
import ProductDetailView from './components/ProductDetailView';

function Products({ openDialog, isEdit, handleSubmit, handleEdit, handleClose }) {
  const { detail } = useSelector((state) => state.product);

  return (
    <div className="flex-1 min-w-0 flex flex-col">
      {detail && <ProductDetailView data={detail} onEdit={handleEdit} />}
      <ProductModal
        title="Výrobek"
        visible={openDialog}
        formProps={isEdit ? detail : null}
        onSubmit={handleSubmit}
        onClose={handleClose}
      />
    </div>
  );
}

export default withDbItemsWrapper(
  Products,
  'product',
  'left-panel-product/',
  '/app/data/reseni/vyrobky/'
);
